module.exports = __webpack_public_path__ + "img/no-items.a140ba79.svg";